/*
 * poaime-scroll — Révélations au défilement « façon Apple » (fondu + glissé + léger scale).
 * Best practices : IntersectionObserver, respecte prefers-reduced-motion, dégradation gracieuse
 * (si JS absent : aucun contenu masqué), pas de flash (les sections déjà visibles s'affichent direct).
 */
(function () {
  if (window.__poaimeScroll) return;
  window.__poaimeScroll = true;

  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return; // accessibilité : pas d'animation

  function init() {
    if (!('IntersectionObserver' in window)) return;

    var scope = document.querySelector('main') || document.body;
    var targets = [].slice.call(scope.querySelectorAll('.shopify-section'));
    // On n'anime pas le hero 3D (il a déjà sa propre mise en scène).
    targets = targets.filter(function (el) { return !el.querySelector('.poaime-hero-3d'); });
    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('poaime-reveal--in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    var vh = window.innerHeight || document.documentElement.clientHeight;
    targets.forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      if (top < vh * 0.92) {
        // Déjà visible au chargement : on affiche sans animation d'entrée (zéro flash).
        el.classList.add('poaime-reveal', 'poaime-reveal--in');
      } else {
        el.classList.add('poaime-reveal');
        io.observe(el);
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
